import CameraFeed from "components/Camera/CameraFeed";
import PropTypes from "prop-types";

function CameraFeedTab({ device, deviceLayout, directionTrigger }) {
    return <CameraFeed {...{ device, deviceLayout, directionTrigger }} />
}

CameraFeedTab.propTypes = {
    device: PropTypes.object,
    deviceLayout: PropTypes.string,
    directionTrigger: PropTypes.object
}

export default CameraFeedTab;